<template>
  <div class="subs">
    <va-card class="chart-widget" title="Historico Inscrições nos ultimos 30 dias">
      <line-chart class="chart" :chart-data="subsData" :options="options"/>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import LineChart from '../../reports/LineChart.js'
export default {
  name: 'Subs',
  components: { LineChart },
  methods: {
  },
  data () {
    return {
      inscricoes: [],
      subs: [],
      subsData: [],
      loading: false,
      options: {
        legend: {
          display: false,
        },
        tooltips: {
          bodyFontSize: 14,
          bodyFontFamily: 'sans-serif',
        //   enabled: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              stepSize: 2,
            },
          }],
        },
      },
    }
  },
  apollo: {
    inscricoes: {
      query: gql`
      query MyQuery {
        inscricoes: qtd_subscribes_last_30_days {
          data
          value
        }
      }
      `,
      result ({ data, loading }) {
        const moment = this.$moment
        if (!loading && Object.keys(data).includes('inscricoes')) {
          this.inscricoes = data.inscricoes
          this.subs = data.inscricoes.map(c => {
            return { x: c.data, y: c.value }
          })
          this.subsData = {
            labels: this.subs.map(c => { return moment(c.x).format('DD/MM/YYYY') }), // months.splice(firstMonthIndex, size),
            datasets: [
              {
                backgroundColor: '#f2e5e680',
                borderColor: '#943435',
                data: this.subs,
                tension: 0,
              },
            ],
          }
        }
      },
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('inscricoes')) {
      this.$apollo.queries.inscricoes.refetch()
    }
  },
}
</script>

<style lang="scss">
.chart-widget {
  .va-card__body {
    height: 300px;
  }
}

.chart {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    height: 100%;
    width: 100%;
  }

  canvas {
    width: 100%;
    height: auto;
  }
}
</style>
